<template>
  <div>
    <FormSection :name="$t('meta.zoneIdentifier')" :childrenCount="1">
      <div>
        <div class="row row-gutter-20">
          <div class="col-8">
            <FormInput
              v-model="newZoneIdentifier.name"
              :name="$t('meta.name')"
              @input="v => updateIdentifierDirty(v)"
            />
          </div>
          <div class="col-8">
            <FormSelect
              v-model="newZoneIdentifier.identifier_type_name"
              :name="$t('containers.identifierType')"
              :options="identifierTypeValueOptions"
            />
          </div>
          <div class="col-8">
            <FormInput
              v-model="newZoneIdentifier.value"
              :name="$t('identifiers.value')"
              @input="v => updateIdentifierDirty(v)"
            />
          </div>
        </div>
        <div class="form-wrap">
          <button
            type="button"
            class="zone-identifier__action button button-green button-small button-round"
            :disabled="!identifierDirty"
            @click="createZoneIdentifier"
          >
            <span class="material-icons">done</span>
          </button>
          <button
            type="button"
            class="zone-identifier__action button button-small button-round"
            :disabled="!identifierDirty"
            @click="handleRevert"
          >
            <span class="material-icons">undo</span>
          </button>
          <button
            type="button"
            class="zone-identifier__action button button-red button-small button-round"
            :disabled="Object.values(identifier).every(identifierValue => identifierValue.length === 0)"
            @click="deleteZoneIdentifier"
          >
            <span class="material-icons">delete</span>
          </button>
        </div>
      </div>
    </FormSection>
  </div>
</template>

<script>
import FormInput from '@/components/Form/Input/index.vue'
import FormSelect from '@/components/Form/Select'

import categoryValuesApi from '@/api/categoryValues'
import industryZoneIdentifiersApi from '@/api/industry/zones/identifiers'

export default {
  name: 'ZoneIdentifier',
  components: { FormInput, FormSelect },
  props: {
    identifier: { type: Object, required: true },
    zoneUuid: { type: String },
  },
  data() {
    return {
      identifierDirty: false,
      identifierTypeValues: [],
      newZoneIdentifier: { ...this.identifier },
    }
  },
  emits: ['zone-identifier-created'],
  computed: {
    identifierTypeValueOptions() {
      return this.identifierTypeValues?.map(identifierTypeValue => ({
        value: identifierTypeValue.name,
        label: identifierTypeValue.text,
      }))
    },
  },
  methods: {
    updateIdentifierDirty() {
      const nameDirty = this.newZoneIdentifier.name !== this.identifier.name
      const typeNameDirty = this.newZoneIdentifier.identifier_type_name !== this.identifier.identifier_type_name
      const valueDirty = this.newZoneIdentifier.value !== this.identifier.value
      this.identifierDirty = nameDirty || typeNameDirty || valueDirty
    },
    handleRevert() {
      this.newZoneIdentifier = { ...this.identifier }
      this.updateIdentifierDirty()
    },
    async createZoneIdentifier() {
      const newIdentifier = {
        ...this.newZoneIdentifier,
        zone_uuid: this.zoneUuid,
      }
      const response = await industryZoneIdentifiersApi.create(newIdentifier)
      if (response.success) {
        this.$emit('zone-identifier-created')
      }
    },
    async deleteZoneIdentifier() {
      const response = await industryZoneIdentifiersApi.delete(this.zoneUuid)
      if (response.success) {
        this.newZoneIdentifier = {
          ...{ name: '', identifier_type_name: '', value: '' },
        }
      }
    },
    async getCategoryValues(context, category) {
      this.identifierTypeValues = await categoryValuesApi.get(context, category)
    },
  },
  async mounted() {
    await this.getCategoryValues('containers', 'identifier_type')
  },
}
</script>

<style scoped>
@import './ZoneIdentifier.css';
</style>
